<template>
    <div class="comments">

        <template v-if="commentList.length">
            <transition-group name="slide-left" tag="div" class="comments-list">
                <div class="comment" v-for="comment in commentList" :key="comment.uid">
                    <header>
                        <p>Kommentar
                            <time class="comment-date" :datetime="comment.date | toMiliSeconds | dateFormat('Y-m-d')">{{comment.date | toMiliSeconds | dateFormat( "d. F H:i" ) }} <span>Uhr</span></time>
                        </p>
                        <p class="comment-author">{{comment.author}}</p>
                    </header>
                    <main class="comment-text">
                        {{comment.description}}
                    </main>
                </div>
            </transition-group>
        </template>
        <span class="load-more" v-if="commentCount > maxCount" @click="maxCount = maxCount + 3">Mehr laden</span>
        <span class="comment-toggle button button--primary" @click="toggleForm" v-if="!writeComment">Neuer Kommentar</span>
        <div class="comments-form" v-show="writeComment">
            <div class="comment form">
                <header>
                    <p>neuer Kommentar</p>
                    <!--                    <p class="comment-author">{{user.fullName}}</p>-->
                </header>
                <p class="comment-text">
                    <textarea rows="6" cols="25" :maxlength="(maxLength > 0 ? maxLength : false)" placeholder="Mein Kommentar ..." v-model="postData.description"></textarea>
                    <small v-if="maxLength > 0">max. {{maxLength}} Zeichen</small>
                </p>
            </div>
            <p class="comment-submit">
                <button @click="submitComment" class="button button--primary">Kommentar veröffentlichen <i class="icon-weiter"></i></button>
            </p>
        </div>
    </div>
</template>

<script>
    import store from "@/utils/store";
    import api, { ApiDefaults } from '../../utils/api_call';
    import Downloadlist from '../subparts/Downloadlist';
    import { ARTICLE_UPDATE } from '../../utils/store/actions/general';

    export default {
        name: "KappNewsComment",
        components: {Downloadlist},
        data() {
            return {
                maxCount: 3,
                maxLength: 0,
                writeComment: false,
                user: store.getters.getProfile,
                postData: {
                    description: '',
                    date: 0
                },
                sendComments: [],
                sortOrder: 'desc'
            };
        },
        props: {
            'comments': {type: Array, required: false},
            'newsid': {type: Number, required: true},
            'newComment': {type: Boolean, default: false},
            'target': {type: String, default: 'news'}
        },
        computed: {
            commentList() {
                // let comments = [].concat.apply( this.sendComments, this.comments);
                return _.orderBy(this.comments, 'date', this.sortOrder).splice(0, this.maxCount);
            },
            commentCount() {
                // let comments = [].concat.apply( this.sendComments, this.comments);
                return this.comments.length;
            }
        },
        methods: {
            toggleForm() {
                this.writeComment = !this.writeComment;
                /**
                 * ToDo: scrollDown
                 */

            },
            appendComment( data ) {
                let newComments = [].concat.apply(this.comments, [ {
                    author: this.user.fullName,
                    description: data.description,
                    date: data.date,
                    uid: data.uid
                } ]);
                this.$store.commit(ARTICLE_UPDATE, {article: {uid: this.newsid}, newData: {comments: newComments}, target: this.target});
            },
            submitComment() {

                let postData = new URLSearchParams(),
                    apiParams = {};
                postData.append('tx_nsnewscomments_newscomment[controller]', 'Comment');
                postData.append('tx_nsnewscomments_newscomment[action]', 'create');
                postData.append('tx_nsnewscomments_newscomment[storagePid]', '18');
                postData.append('tx_nsnewscomments_newscomment[parentId]', 0);
                postData.append('tx_nsnewscomments_newscomment[comment]', 0);
                postData.append('tx_nsnewscomments_newscomment[newComment][description]', this.postData.description);
                postData.append('tx_nsnewscomments_newscomment[newComment][newsuid]', this.newsid);
                postData.append('tx_nsnewscomments_newscomment[newComment][feuserid]', this.user.uid);
                postData.append('tx_nsnewscomments_newscomment[newComment][usermail]', this.user.email);
                postData.append('tx_nsnewscomments_newscomment[newComment][username]', this.user.fullName);
                postData.append('tx_nsnewscomments_newscomment[newComment][pid]', 18);

                apiParams = Object.assign({}, ApiDefaults,
                    {
                        params: {id: 36},
                        // url: ApiDefaults.url + '/news/detailseite?tx_nsnewscomments_newscomment%5Baction%5D=create&tx_nsnewscomments_newscomment%5Bcontroller%5D=Comment&cHash=ff81869367f102d8e221b72bddc547de',
                        method: 'post',
                        data: postData
                    }
                );

                api(apiParams)
                    .then(( response ) => {
                        let data = response.data;
                        if ( data.hasOwnProperty('newComment') ) {
                            this.newComment = false;
                            this.postData.description = '';
                            this.appendComment(data.newComment);
                            this.toggleForm();
                        }
                        else if( data.hasOwnProperty('uid') ) {
                            this.newComment = false;
                            this.postData.description = '';
                            this.appendComment(data);
                            this.toggleForm();
                        }
                    });
            }
        },
        mounted() {
            this.writeComment = this.newComment;
            Events.$on('lightbox', ( data ) => {
                if ( data.state === false ) {
                    this.newComment = false;
                }
            });
        }
    };
</script>

<style scoped>
    .comments:nth-child(n+2) {
        margin-top: 14px;
    }

    .comments-list,
    .comments-form {
        /*padding: 0 16px;*/
    }

    .comments-form {
        margin-top: 15px;

    }

    .comment-toggle {
        margin-top: 16px;
    }

    .load-more + .comment-toggle {
        margin-top: 0;
        /*padding: 16px 10px 16px 0;*/
    }

    .comment-toggle i::before {
        margin-left: 0;
    }

    .comment {
        background: #42556B;
        border-radius: 3px;
        padding: 16px 10px 16px 17px;
        border-left: 3px solid #A1AAB3;
        box-shadow: 0 2px 3px #00000029;
    }

    .comment + .comment {
        margin-top: 5px;
    }

    .comment header {
        font-size: 10px;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        line-height: calc(19 / 14);
    }

    .comment-author {
        margin-top: 6px;
        font-size: 14px;
        font-weight: 700;
        text-transform: none;
    }

    .comment-date {
        color: #A1AAB3;
    }

    .comment-date span {
        text-transform: none;
    }

    .comment-text {
        margin: 16px 0 0;
        line-height: 21px;
    }

    .comments-form .comment {
        border-left-color: #E4223C;
    }

    .comments-form .comment-text small {
        font-size: 10px;
        line-height: 1;
        opacity: .7;
    }

    .comments-form .comment-text textarea {
        width: 100%;
        background: transparent;
        padding: 0;
    }

    .comments-form .comment-submit {
        margin-top: 5px;
    }

    .load-more {
        display: block;
        text-align: center;
        padding: 8px;
        margin: 8px 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/blocks/KappNewsComment.vue